import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpHeaderService} from './http-header.service';
import {HttpClient} from '@angular/common/http';
import {Permits} from '../model/permits';
import {EmployerHoliday} from '../model/employer-holiday';
import {APP_CONFIG} from '../config/app-config.token';
import {AppConfig} from '../config/app-config.model';
import {CapacitorHttpService} from './capacitor-http.service';

@Injectable({
  providedIn: 'root'
})
export class AdmissibilityService {
  private http = inject(HttpClient);
  private capacitorHttp = inject(CapacitorHttpService);
  private httpHeaderService = inject(HttpHeaderService);
  private config = inject<AppConfig>(APP_CONFIG);

  baseurl: string;

  constructor() {
    this.baseurl = this.config.apiGatewayUrl;
  }

  public getEmployerHolidays(memberId: string): Observable<EmployerHoliday> {
    return this.capacitorHttp.get<EmployerHoliday>(
      this.baseurl + `/members/${memberId}/employerholidays`, this.httpHeaderService.getHeaderOptions());
  }

  public getPermits(memberId: string): Observable<Permits> {
    return this.capacitorHttp.get<Permits>(this.baseurl + `/members/${memberId}/permits`, this.httpHeaderService.getHeaderOptions());
  }

  // ========== METHODS FOR EXTERNAL USERS (using /me endpoints) ==========
  // These methods are for external users (members) who can only access their own data.
  // Tyk API Gateway rewrites /members/me to /members/{jwt.preferred_username}

  /**
   * Get employer holidays for authenticated external user
   * @returns Observable<EmployerHoliday>
   */
  public getMyEmployerHolidays(): Observable<EmployerHoliday> {
    return this.capacitorHttp.get<EmployerHoliday>(
      this.baseurl + '/members/me/employerholidays',
      this.httpHeaderService.getHeaderOptions()
    );
  }

  /**
   * Get permits for authenticated external user
   * @returns Observable<Permits>
   */
  public getMyPermits(): Observable<Permits> {
    return this.capacitorHttp.get<Permits>(
      this.baseurl + '/members/me/permits',
      this.httpHeaderService.getHeaderOptions()
    );
  }
}
